import type { IReturnLineItem } from "@repo/shopify/api/fetchOrder";
import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import useOrderLineInfo from "@repo/shopify/hooks/useOrderLineInfo";
import type { OrderLineItem } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";

import Image from "@atoms/Image";
import Price from "@atoms/Price";

import { translationReturnReason } from "@const/constant";

interface IProps {
  node: OrderLineItem | IReturnLineItem;
}

export default function OrderLineItem({ node }: IProps) {
  const { isPC } = useCheckDevice();

  const { compareAtPrice, price } = useOrderLineInfo(node);

  return (
    <li className="tnt-gap-x grid grid-cols-6">
      <div className="col-span-4 flex gap-2.5">
        <Image
          className="pc:w-20 pc:min-w-20 h-fit w-15 min-w-15"
          height={node.variant?.image?.height || 1707}
          src={node.variant?.image?.url || ""}
          width={node.variant?.image?.width || 1280}
        />
        <div className="flex grow flex-col gap-1">
          <div className="pc:flex-row pc:gap-1 flex flex-col">
            <span>{`${node.title} ${node.variant?.title}`}</span>
          </div>
          {!isPC && <span>Qty {node.quantity}</span>}
          {Boolean((node as IReturnLineItem).returnReason) && (
            <span>
              {translationReturnReason[(node as IReturnLineItem).returnReason as keyof typeof translationReturnReason]}
            </span>
          )}
        </div>
      </div>
      {isPC ? <span className="col-span-1">Qty {node.quantity}</span> : null}
      <Price
        className="pc:col-span-1 col-span-2 justify-end text-right"
        compareAtPrice={compareAtPrice}
        direction="vertical"
        price={price}
        variant="secondary"
      />
    </li>
  );
}
